// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-resize[data-v-f011d8fa]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.auto-resize[data-v-f011d8fa]:focus{overflow:hidden}", ""]);
// Exports
module.exports = exports;
